<!--
 * @Author: redu842 2150673512@qq.com
 * @Date: 2023-11-30 17:41:21
 * @LastEditors: redu842 2150673512@qq.com
 * @LastEditTime: 2024-03-28 12:40:50
 * @FilePath: \miniproweb\src\views\EarlyWarning\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="WaringBox">
    <div class="WaringBoxTitle">预警列表</div>
    <div class="mapBox" id="mapwaring"></div>
    <div class="wraingnumbertitle">当前预警信号统计</div>
    <div style="width:100%">
      <el-table :data="waringTyeList" style="width: 100%" empty-text="暂时无预警信号">
        <el-table-column prop="红色" label="红色"></el-table-column>
        <el-table-column prop="橙色" label="橙色"></el-table-column>
        <el-table-column prop="黄色" label="黄色"></el-table-column>
        <el-table-column prop="蓝色" label="蓝色"></el-table-column>
      </el-table>
    </div>
    <div style="margin-top:10px">
      <van-dropdown-menu active-color="#1989fa">
        <van-dropdown-item v-model="value1" :options="option1" @change="typeChange" />
        <van-dropdown-item v-model="value2" :options="option2" @change="typeChange" />
        <van-dropdown-item v-model="value3" :options="option3" />
      </van-dropdown-menu>
      <!-- <el-table :data="WarningList" style="width: 100%" empty-text="暂时无预警信号">
        <el-table-column prop="warnType" label="类型"></el-table-column>
        <el-table-column prop="warnLevelName" label="等级"></el-table-column>
        <el-table-column prop="address" label="全部"></el-table-column>
        <el-table-column prop="address" label="生效中"></el-table-column>
        <el-table-column prop="sender" label="成都市"></el-table-column>
      </el-table>-->
    </div>
    <div class="temPBox" v-show="IsTemp">暂时无预警</div>
    <div
      class="CordBox"
      v-for="item in showWaringList"
      :style="{backgroundColor:leaveList[item.warnLevel-1]}"
      @click="showPopBox(item)"
    >
      <div>
        <div style="color:white">{{item.warnContent}}</div>
        <div style="color:white;margin-top:10px">{{item.issueTime}}</div>
      </div>
      <div>
        <img
          :src="'https://moodsci.com/mimiproweb/img/'+item.iconNo +'.png'"
          style="width:80px;height:50px"
          alt
        />
      </div>
    </div>
    <div></div>
    <van-popup v-model="show" position="bottom" :style="{ height: '50%' }">
      <div class="PopTitle">预警详情</div>
      <div class="waringPopItem">
        <div class="waringPopLable">预警类型:</div>
        <div>{{chooseForData.warnType}}</div>
      </div>
      <div class="waringPopItem">
        <div class="waringPopLable">预警等级:</div>
        <div>{{chooseForData.warnLevelName}}</div>
      </div>
      <div class="waringPopItem2">
        <div class="waringPopLable2">预警内容:</div>
        <div style="width:70%">{{chooseForData.warnContent}}</div>
      </div>
      <div class="waringPopItem">
        <div class="waringPopLable">经纬度:</div>
        <div>{{chooseForData.lon}}，{{chooseForData.lat}}</div>
      </div>
      <div class="waringPopItem">
        <div class="waringPopLable">发布时间:</div>
        <div>{{chooseForData.issueTime}}</div>
      </div>
      <div class="waringPopItem">
        <div class="waringPopLable">解除时间:</div>
        <div>{{chooseForData.relieveTime}}</div>
      </div>
      <div class="waringPopItem">
        <div class="waringPopLable">是否解除:</div>
        <div>{{chooseForData.ifreLieve}}</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import moment from "moment";
import { MapCreate, legendColor } from "../../map/mapImport.js";
export default {
  data() {
    return {
      WarningList: [],
      leaveList: ["#00a8ff", "#f9ca24", "#ff793f", "#ff5252"],
      show: false,
      chooseForData: {},
      IsTemp: false,
      waringTyeList: [],
      showWaringList: [],
      value1: "all",
      value2: "all",
      value3: "1",
      option1: [
        { text: "全部类型", value: "all" },
        { text: "高温", value: "高温" },
        { text: "森林火险", value: "森林火险" },
        { text: "冰雹", value: "冰雹" },
        { text: "道路结冰", value: "道路结冰" },
        { text: "暴雨", value: "暴雨" },
        { text: "暴雪", value: "暴雪" },
        { text: "大风", value: "大风" },
        { text: "雷电", value: "雷电" },
        { text: "大雾", value: "大雾" },
        { text: "霜冻", value: "霜冻" },
        { text: "强降温", value: "强降温" },
        { text: "霾", value: "霾" }
      ],
      option2: [
        { text: "全部等级", value: "all" },
        { text: "红色", value: "红色" },
        { text: "橙色", value: "橙色" },
        { text: "黄色", value: "黄色" },
        { text: "蓝色", value: "蓝色" }
      ],
      option3: [
        { text: "全部", value: "all" },
        { text: "生效中", value: "1" },
        { text: "已失效", value: "0" }
      ]
    };
  },
  created() {
    this.getWarningList();
  },
  mounted() {
    this.map = new MapCreate();
    //   this.map.init();
    this.map.init("mapwaring");
  },
  methods: {
    showWaringMap(data) {
      this.$axios({
        method: "post",
        // url: `https://geo.datav.aliyun.com/areas_v3/bound/${data.areaCode}.json`,
        url: `https://www.moodsci.com/chongzhou/dataService/getJson`,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        data: {
          areaCode: data.areaCode
        }
      }).then(res => {
        // console.log();
        L.geoJSON(res.data.features, {
          style: {
            color: "#000", //线颜色
            weight: 1, //线粗细
            opacity: 1, //透明度
            fillColor: this.leaveList[data.warnLevel - 1], //区域填充颜色
            fillOpacity: 0.5 //区域填充颜色的透明
          }
        }).addTo(this.map.map);
      });
    },
    getImgurl(img) {
      return require("../../assets/waringIcon/" + img + ".png");
    },
    showPopBox(data) {
      this.show = true;
      this.chooseForData = data;
    },
    getWarningList() {
      this.$axios({
        method: "get",
        url: `http://120.79.183.250:3093/InterfaceServices/WarningService/queryWarnInfoList?startDate=${moment().format(
          "YYYY-MM-DD HH:00:00"
        )}&endDate=${moment().format("YYYY-MM-DD HH:00:00")}`,
        // url: `http://120.79.183.250:3093/InterfaceServices/WarningService/queryWarnInfoList?startDate=2023-01-01 08:00:00&endDate=2024-01-01 08:00:00`,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
        .then(res => {
          // this.cropListData = res.data.data;
          // console.log(res.data.data);
          this.WarningList = res.data.data;
          this.showWaringList = res.data.data;

          let LevelList = this.WarningList.map(item => {
            //将等级统计出来 ['A','B']
            return item.warnLevelName;
          });
          if (this.WarningList.length != 0) {
            let contList = LevelList.reduce(function(prev, next) {
              //将等级计数统计 {A:3,B:2}
              prev[next] = prev[next] + 1 || 1;
              return prev;
            }, {});
            console.log(contList);
            this.waringTyeList = [contList];
          } else {
            this.waringTyeList = [];
          }

          if (this.WarningList.length == 0) {
            this.IsTemp = true;
          }

          this.WarningList.map(item => {
            this.showWaringMap(item);
          });

          // this.chooseCropTimeData = res.data.data.code;
          // this.chooseCropTimeDataChange(res.data.data.code);
          // this.list = res.data;
        })
        .catch(() => {
          let TestList = [
            {
              id: 556238,
              issueTime: "2022-04-05 07:00:07",
              lon: 103,
              lat: 30,
              warnType: "大雾",
              warnLevel: "2",
              warnContent: "崇州市气象台发布大雾黄色预警信号",
              ifreLieve: "0",
              relieveTime: null,
              pushStatus: "0",
              warnLevelName: "黄色",
              iconNo: "大雾_黄色预警",
              areaCode: "510184"
            }
          ];
          // this.WarningList.map(item => {
          //   this.showWaringMap(item);
          // });
          TestList.map(item => {
            this.showWaringMap(item);
          });
        });
    },
    typeChange() {
      console.log(this.value2);
      if (this.value1 != "all" && this.value2 != "all") {
        this.showWaringList = this.WarningList.filter(
          item =>
            item.warnType == this.value1 && item.warnLevelName == this.value2
        );
      } else if (this.value1 == "all" && this.value2 == "all") {
        console.log(this.WarningList);
        this.showWaringList = this.WarningList;
      } else if (this.value2 == "all") {
        this.showWaringList = this.WarningList.filter(
          item => item.warnType == this.value1
        );
      } else if (this.value1 == "all") {
        console.log(1111);
        this.showWaringList = this.WarningList.filter(
          item => item.warnLevelName == this.value2
        );
      }

      console.log(this.showWaringList);
    }
  }
};
</script>

<style>
.WaringBox {
  height: 100vh;
  width: 100vw;
  background-color: #111b2f;
  padding: 0 10px;
  overflow-y: auto;
}
.WaringBoxTitle {
  height: 50px;
  width: 100%;
  text-align: center;
  line-height: 50px;
  color: white;
}
.CordBox {
  height: auto;
  width: 100%;
  background-color: #263045;
  border-radius: 10px;
  margin-top: 15px;
  padding: 10px;
  display: flex;
  justify-content: space-between;
}
.PopTitle {
  height: 30px;
  width: 100%;
  text-align: center;
  line-height: 30px;
}
.waringPopItem {
  height: 30px;
  width: 100%;
  padding: 0 20px;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
}
.waringPopItem2 {
  height: 100px;
  width: 100%;
  padding: 0 20px;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.waringPopLable {
  height: 30px;
  width: 30%;
  line-height: 30px;
}
.waringPopLable2 {
  height: 30px;
  width: 30%;
  line-height: 30px;
}
.temPBox {
  height: 100vh;
  width: 100%;
  color: rgb(165, 165, 165);
  text-align: center;
  font-size: 12px;
  line-height: 100px;
}
.mapBox {
  height: 50vh;
  widows: 100%;
  background-color: aqua;
}
.wraingnumbertitle {
  height: 30px;
  width: 100%;
  /* background-color: aqua; */
  margin-top: 15px;
  text-align: center;
  line-height: 30px;
  color: white;
}
</style>